export default [
  // 关联设备弹窗
  {
    name: 'associated-devices-popup',
    component: () => import(/* webpackChunkName: "associatedDevicesPopup" */ './associated-devices-popup.vue'),
  },
  // 自定义视频类型弹窗
  {
    name: 'video-type-custom-popup',
    component: () => import(/* webpackChunkName: "videoTypeCustomPopup" */ './video-type-custom-popup.vue'),
  },
  // 自定义视频类型编辑弹窗
  {
    name: 'video-type-edit-popup',
    component: () => import(/* webpackChunkName: "videoTypeEditPopup" */ './video-type-edit-popup.vue'),
  },
  // 编辑视频信息
  {
    name: 'moment-edit-popup',
    component: () => import(/* webpackChunkName: "momentEditPopup" */ './moment-edit-popup.vue'),
  },
];
